export const featureFlags = {
  noticeBanner: "notice-banner",
  walletButton: "wallet-button",
  tradeButton: "trade-button",
  topBanner: "top-banner",
  disableBridge: "disable-bridge",
  depositConfig: "deposit-config",
  equityButton: "equity-button",
  transferButton: "transfer-button",
  withdrawButton: "withdraw-button",
  realtimeLastTrades: "realtime-last-trades",
  disableOneClickTrading: "disable-1-click-trading",
};
